import React, { ReactNode, useState } from 'react';
import ThumbLinkIcon from '%/public/assets/images/icons/thumb_link.svg';
import { Recording } from '~/types/models';
import ShareTabContent from './ShareTabContent';
import TabItem from './TabItem';

export enum Tab {
  VideoLink = 'videoLink',
  ThumbAndLink = 'thumbAndLink',
  EmbedVideo = 'embedVideo',
  MailTo = 'mailTo',
}

export type ShareTabProps = {
  recording: Recording;
  title?: ReactNode;
  redirect?: boolean;
};

export default function ShareTab({
  title,
  recording,
  redirect,
}: ShareTabProps) {
  const [activeTab, setActiveTab] = useState<Tab>(Tab.VideoLink);
  const onRequestTab = (tab: Tab) => {
    if (redirect && (tab === Tab.ThumbAndLink || tab === Tab.EmbedVideo)) {
      window.location.href = `/recordings/${recording.type}/${recording.id}/edit`;
      return;
    }

    if (tab === Tab.MailTo) {
      window.location.href = `mailto:?subject=${recording.name}&body=${recording.public_url}`;
      return;
    }

    setActiveTab(tab);
  };

  return (
    <>
      {title}
      <div className='flex justify-between m-auto w-11/12'>
        <TabItem
          title='Video link'
          tab={Tab.VideoLink}
          icon={<i className='fa fa-link' />}
          onRequestTab={onRequestTab}
          activeTab={activeTab}
        />
        <TabItem
          title='Thumb & link'
          tab={Tab.ThumbAndLink}
          icon={<ThumbLinkIcon />}
          onRequestTab={onRequestTab}
          activeTab={activeTab}
        />
        <TabItem
          title='Embed video'
          tab={Tab.EmbedVideo}
          icon={<i className='fa fa-code' />}
          onRequestTab={onRequestTab}
          activeTab={activeTab}
        />
        <TabItem
          title='Mailto:'
          tab={Tab.MailTo}
          icon={<i className='fa fa-envelope' />}
          onRequestTab={onRequestTab}
          activeTab={activeTab}
        />
      </div>
      <div className='w-full text-center'>
        <ShareTabContent
          title='Copy video link'
          ctaButtonText='Copy link'
          recording={recording}
          active={activeTab === Tab.VideoLink}
          tab={Tab.VideoLink}
          linkToCopy={recording.public_url}
        />
        <ShareTabContent
          title='Copy thumbnail and video link'
          ctaButtonText='Copy link and thumbnail'
          recording={recording}
          active={activeTab === Tab.ThumbAndLink}
          tab={Tab.ThumbAndLink}
        />
        <ShareTabContent
          title='Embed video'
          ctaButtonText='Copy link'
          recording={recording}
          active={activeTab === Tab.EmbedVideo}
          tab={Tab.EmbedVideo}
          linkToCopy={recording.iframe}
        />
      </div>
    </>
  );
}
